<template>
  <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      :fill="color"
      d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6zm-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2"
    />
  </svg>
</template>

<script>
export default {
  name: 'BellIcon',
  props: {
    width: {
      type: Number,
      default: 6
    },
    height: {
      type: Number,
      default: 6
    },
    color: {
      type: String,
      default: '#4196F0'
    }
  }
}
</script>

<style scoped></style>
